;(function() {
  'use strict';

  if(!isMobile.phone) {
    const nav = document.querySelector('#navbar');
    const button = document.querySelector('#fixed-book-now');
    if(!nav || !button) return true;

    let displayHeight = 0,
        scrollCurr = 0;

    window.addEventListener('scroll', function() {
      displayHeight = 200;
      scrollCurr = window.pageYOffset;

      if(scrollCurr <= displayHeight) {
        if(button.classList.contains("animate")) {
          button.classList.remove("animate");
        }
      } else {
        if(!button.classList.contains("animate")) {
          button.classList.add("animate");
        }
      }
    });
  }
}());


// WEBPACK FOOTER //
// ./public/javascripts/modules/fixedBookNow.js